/**
 * API Key Status — Sprint 17g4 Task 5.9
 *
 * Diagnostic helper that reports which agent API keys are configured
 * and what fallback mode is available when they're missing.
 */

import { shouldUseLLMProxy } from '../lib/openai-proxy';

export interface AgentKeyStatus {
  agent: string;
  key: string;
  configured: boolean;
  fallback: 'llm' | 'none';
}

export function getAgentKeyStatus(): AgentKeyStatus[] {
  const proxyConfigured = shouldUseLLMProxy();
  return [
    { agent: 'shopping', key: 'SERPER_API_KEY server proxy', configured: proxyConfigured, fallback: 'llm' },
    { agent: 'restaurant', key: 'GOOGLE_PLACES_API_KEY server proxy', configured: proxyConfigured, fallback: 'llm' },
    { agent: 'travel', key: 'SERPAPI_API_KEY server proxy', configured: proxyConfigured, fallback: 'none' },
    { agent: 'events', key: 'TICKETMASTER_API_KEY server proxy', configured: proxyConfigured, fallback: 'llm' },
    { agent: 'content', key: 'NEWS_API_KEY server proxy', configured: proxyConfigured, fallback: 'llm' },
    { agent: 'cooking', key: 'SERPER_API_KEY server proxy', configured: proxyConfigured, fallback: 'llm' },
  ];
}
